export default "__VITE_ASSET__DrH2A1jz__ 400w, __VITE_ASSET__BQ7It7PP__ 800w, __VITE_ASSET__UNwku_x0__ 1024w";